export default "__VITE_PUBLIC_ASSET__0be4ced6__"